import { withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";
import { Badge, Card, CardBody, CardHeader, Col, Row } from "reactstrap";

const ComplianceRisks = ({ t, complianceQuery, assetId }) => {
    if (complianceQuery.isFetching) return null;

    const {
        platform
    } = complianceQuery.data?.data || {};

    return (
        <Card>
            <CardHeader>
                <h5 className="mb-0">
                    {t('Open Compliance Risks')}
                </h5>
            </CardHeader>

            <CardBody>
                <Row>
                    {platform?.openRiskRates?.map(risk => (
                        <Col
                            lg={6}
                            key={risk.riskRateId}
                        >
                            <Card className="border">
                                <CardBody>
                                    <div className="d-flex justify-content-between">
                                        <h6 className="mb-0">
                                            <Link
                                                to={`/admin/data-protection/softwares/${assetId}?tab=risk-assessment&id=${risk.riskRateId}`}
                                                className="link-body-emphasis text-decoration-none fw-medium"
                                            >
                                                R{risk.secondaryId}
                                            </Link> - {risk.title}
                                        </h6>

                                        <Badge className="bg-light" color="light">
                                            {t(risk.category)}
                                        </Badge>
                                    </div>

                                    {risk.rating && (
                                        <div className="mt-2">
                                            <span className="me-1">{t('Rating')}:</span> 
                                            <Badge
                                                style={{
                                                    backgroundColor: `#${risk.resultColor}`
                                                }}
                                            >
                                                {risk.rating}
                                            </Badge>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    ComplianceRisks
);